<template>
    <v-dialog-old
        ref="priceMassActionsDialog"
        class="glue"
        :special-styles="{ width: '800px', overflow: 'visible' }"
        @hidden="reset"
        :onCloseEsc="reset"
        :overflow="true"
    >
        <fieldset style="overflow: initial !important;">
            <legend><span>Массовое редактирование</span></legend>
            <form>
                <table class="grid">
                    <tr>
                        <td>
                            <div class="large">
                                {{ selectedPriceLines.length | pluralize('$ услуг', '$ услуга', '$ услуги', '$ услуг') }}
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td style="width:50%">
                            <label>Действие</label>
                            <select class="large" v-model="action">
                                <option
                                    v-for="option in options"
                                    v-bind:value="option.action"
                                    :selected="option.action === action"
                                    :disabled="option.action === null"
                                >{{ option.name }}</option>
                            </select>
                        </td>
                        <MassActionsMethods
                            :action="action"
                            v-bind="$props"
                            ref="actionMethods"
                            v-on="$listeners"
                            @actionEnded="handleActionEnd"
                            @done="$refs.priceMassActionsDialog.hide()"
                        />
                    </tr>
                </table>
            </form>
        </fieldset>
        <footer>
            <v-loading-component @click="(btn, e) => submit(btn,action === 'deleteLines')">
                <template slot-scope="{ loadingClass }">
                    <button :class="[{green: true}, loadingClass]" :disabled="disableBtn()">Применить</button>
                </template>
            </v-loading-component>
            <v-loading-component @click="(btn, e) => submit(btn, true)">
                <template slot-scope="{ loadingClass }">
                    <button :class="[{green: true}, loadingClass]" :disabled="disableBtn()">Применить и сбросить</button>
                </template>
            </v-loading-component>
        </footer>
    </v-dialog-old>
</template>

<script>
    import MassActionsMethods from "./MassActionsMethods";
    export default {
        components: {MassActionsMethods},
        props: {
            selectedPriceLines: {
                type: Array,
                required: true,
            },
        },
        data: () => ({
            options: [
                {action: null, name: "Выберите действие"},
                {action:"appendTag", name: "Добавить тег"},
                {action:"declineTag", name: "Отклонить тег"},
                {action:"updatePrice", name: "Изменить цену"},
                {action:"updateCategory", name: "Добавить/изменить категорию"},
                {action:"deleteCategory", name: "Удалить категорию"},
                {action:"deleteLines", name: "Удалить услуги"},
            ],
            action: null,
            actionStarted: false,
            submitBtn: null,
        }),
        methods: {
            open() {
                this.$refs.priceMassActionsDialog.show()
            },
            reset() {
                this.action = null
            },
            submit(btn, withReset = false) {
                if (this.disableBtn() || this.actionStarted) {
                    return;
                }

                this.actionStarted = true;
                this.submitBtn = btn;

                this.submitBtn.startLoadingAnimation();
                this.$refs.actionMethods.startAction(withReset, btn)
            },
            disableBtn() {
                return !this.action ||
                    (
                        ['appendTag', 'declineTag', 'updateCategory', 'deleteCategory'].includes(this.action) &&
                        !this.$refs.actionMethods.optional
                    )
            },
            handleActionEnd() {
                this.actionStarted = false;
                this.submitBtn.stopLoadingAnimation();
            }
        }
    }
</script>
